(function() {

    /** Chat Widget Controller **/
    SUGApp.controller('chatWidgetController', ['$scope', 'chatWidgetService', 'SUGUtilities', '$timeout', '$location','userService', function($scope, chatWidgetService, SUGUtilities, timeout, loc, userService){

        // variables for chat
        $scope.displayChatModal = false;
        $scope.chatSupportImg = '';
        $scope.member_name = '';
        $scope.member_email = '';
        $scope.memberid = 0;
        $scope.label = encodeURIComponent('Collect Payment Inquiry');
        $scope.chatsrc = 'https://signupgenius.desk.com/customer/widget/chats/new?q=c$p&ticket[labels_new]=' + $scope.label + '&h=' + loc.host();
        $scope.chatid = 0;
        $scope.hasPayments = false;

        /*
         Handle Chat
         Determine if chat is available
         Show chat modal button
         */
         $scope.chatNow = function(chatWidgetName){  // 'Collect $ Page Chat'

            // check member
            chatWidgetService.getMemberInfo({"memberonly":true})
                .then( function(response){
                    var r = SUGUtilities.lowerCaseKeys(response);
                    var minfo = angular.isDefined(r.data.data) ? r.data.data : {"fullname":"","email":"","haspayments":false};
                    $scope.member_name = angular.isDefined(minfo.fullname) ? minfo.fullname : '';
                    $scope.member_email = angular.isDefined(minfo.email) ? minfo.email : '';
                    $scope.hasPayments = angular.isDefined(minfo.haspayments) ? minfo.haspayments : false;
                    if( !$scope.hasPayments )
                        return chatWidgetService.showChatWidget({chatwidgetname:chatWidgetName});
                })
                .then( function(widget){
                    if( !angular.isDefined(widget) )
                        return false;

                    if ( chatWidgetService.ajaxResultInvalid(widget)) {
                        // invalid response, show error
                        // chatWidgetService.errorHandler(response.data);
                        return false;
                    }
                    else {
                        var r = SUGUtilities.lowerCaseKeys(widget);
                        if( angular.isDefined(r.data.data) && r.data.data ){  // show chat option
                            // set chat support rep image
                            setSupportImage();
                            // launch chat modal
                            $scope.displayChatModal = true;
                            // play sound
                            playChatSound();
                            // get chatwidgetid
                            $scope.getChatWidgetId(); // c1
                        }
                    }
                });
        };


        // opens the chat window
        $scope.showChatWidget = function(){
            // concat name and email when applicable
            if( $scope.member_email !== '' )
                $scope.chatsrc += '&interaction[email]=' + $scope.member_email;
            if( $scope.member_name !== '' )
                $scope.chatsrc += '&interaction[name]=' + encodeURIComponent($scope.member_name);

            // close the chat button
            $scope.displayChatModal = false;

            // open chat window
            $.magnificPopup.open({
                id : 'chatframeId',
                mainClass: 'mfp-fade',
                removalDelay: 300,
                items: {
                    src: $scope.chatsrc
                },
                type: 'iframe',
                closeOnBgClick: false,

                callbacks: {
                    close: function() {
                        $scope.displayChatModal = true;
                    }
                  }
            });

        };

        // method to get the chat widget id
        $scope.getChatWidgetId = function(){
            chatWidgetService.getChatWidgetIdByName({
                chatwidgetname:'Collect $ Page Chat'
            }).then(function(response){
                // Test for malformed response
                if (chatWidgetService.ajaxResultInvalid(response)) {
                    // invalid response, show error
                    // chatWidgetService.errorHandler(response.data);
                    return false;
                }
                else {
                    var r = SUGUtilities.lowerCaseKeys(response);
                    // get chat ID
                    $scope.chatid = ( r.data.data ) ? r.data.data : 0;
                    $scope.chatsrc += '&cid=' + $scope.chatid;
                    $scope.recordHistory(); //c2
                }
            });
        };

        // method for recording history when applicable
        $scope.recordHistory = function(){
            // if the memberid is defined then we'll record it
            if( $scope.memberid > 0 ){
                chatWidgetService.recordChatHistory({
                    memberid: $scope.memberid,
                    chatwidgetid: $scope.chatid
                }).then(function(response){
                    // this is non blocking requrest. we do nothing.
                });
            }
        };


        /*
         Close chat button
         Hide chat modal button
         */
         $scope.hideChatModal = function(){
            $scope.displayChatModal = false;
        };


        /*
         Get Chat Image
         Select image of support rep randomly
         */
         var setSupportImage = function(){
            var supportImages = [
                'amanda-primary-2x.jpg',
                'kelly-primary-2x.jpg',
                'debbie-primary-2x.jpg',
                'Angie-Primary-2x.jpg',
                'stephanie-primary-2x.jpg'
            ];
            // assign image
            $scope.chatSupportImg = '/images/staff-pic-thumbnails/';
            $scope.chatSupportImg += supportImages[Math.floor((Math.random() * supportImages.length))];
        };

        /*
         Play sound
         Used when chat modal button is displayed
         */
         var playChatSound = function() {
            var audio = new Audio('/assets/button-35.mp3');
            audio.play();
        };

        // delay chat
        timeout(function(){
            $scope.chatNow('Collect $ Page Chat');
        }, 3000);

    }]); // end controller

}());
